<template>
  <!-- Portfolio Section -->
  <div class="blog-detail service-portlet">
    <div class="container">
      <div class="blog-listing">
        <!-- Content Area -->

        <article class="type-post">
          <!--<div class="entry-cover">-->
          <!--<img src="static/images/blog/1/1.png">-->
          <!--</div>-->
          <div class="blog-detail-contentbox">
            <h3>i-award smart app award 건강/의료분야  대상 수상</h3>
            <p class="post-date"><span class="font-color-afblue">Posted at </span>12.07, 2017</p>
            <div class="contentbox-body">
              <div class="imagebox">
                <img src="static/images/blog/2/2.png">
                <p>i-award smart app award 건강/의료분야  대상 상장</p>
              </div>
              <p>
                레나소프트웨에서 개발한 함소아 어플리케이션이 2017년도 App Award Korea에서 건강/의료분야 대상을 수상하였습니다.
                각계 각층의 전문가들과 종사자들이 평가하고 시상하는 권위있는 “앱어워드 2017” 행사가 2017년 12월 7일 잠실 롯데 호텔에서 진행 되었습니다.
                앱 어워드 2017행사는 2017년도 한해 동안 제작하였던 앱을 회원들과 전문 평가위원들이 함께 평가하고, 시상하고, 기술 발전을 위해 함께 논의하는 자리입니다.
              </p>
              <p>수 많은 사람들이 시상식에 참여하였고 축하무대가 한창이었습니다.</p>
              <div class="imagebox">
                <img src="static/images/blog/2/2_1.jpg">
              </div>
              <p style="font-size: 24px; font-weight: 700;text-align: center">건강/의료분야 대상 (함소아 어플리케이션, 레나소프트웨어)</p>
              <div class="imagebox">
                <img src="static/images/blog/2/2_2.JPG">
              </div>
              <p>드디어 레나소프트웨어가 호명 되었고, 권병천 대표가 수상을 받으려고 단상에 올라갔습니다.</p>
              <div class="imagebox">
                <img src="static/images/blog/2/2_3.JPG">
              </div>
              <p>레나소프트웨어는 앞으로도 더욱 성장하고 발전하는 모습을 보여드릴 것을 약속드리며, 무엇보다고 고생하신 분들께 감사의 말씀을 드립니다.^^</p>
            </div>
          </div>
          <!--<div class="tags">-->
          <!--<h3 class="block-title">homepage : </h3>-->
          <!--<a href="http://www.lunchstar.co.kr/" target="_blank" >www.lunchstar.co.kr</a>-->
          <!--<ul>-->
          <!--</ul>-->
          <!--</div>-->

        </article>

        <!-- Related Post -->
        <div class="related-post">
          <h3 class="block-title">recent blog</h3>
          <div class="row">
            <!--<div class="row-3">-->
            <!--<article class="type-post">-->
            <!--<div class="entry-cover">-->
            <!--<a title="Cover" href="blog_detai_2.html"><img src="static/images/blog/2/2.png"></a>-->
            <!--</div>-->
            <!--<div class="entry-contentbox">-->
            <!--<div class="entry-title">-->
            <!--<a title="Single post with image" href="blog_detai_2.html"><h3>i-award smart app award 건강/의료분야  대상 수상</h3></a>-->
            <!--</div>-->
            <!--<p class="post-date"><span class="font-color-afblue">Posted at </span>12.07, 2017</p>-->
            <!--</div>-->
            <!--</article>-->
            <!--</div>-->
            <div class="row-3">
              <article class="type-post">
                <div class="entry-cover">
                  <a title="Cover" v-on:click="goBlogDetail(1)"><img src="static/images/blog/1/1.png"></a>
                </div>
                <div class="entry-contentbox">
                  <div class="entry-title">
                    <a title="Single post with image" v-on:click="goBlogDetail(1)"><h3>식당 고객  만족도 조사 서비스 런치스타 출시</h3></a>
                  </div>
                  <p class="post-date"><span class="font-color-afblue">Posted at </span>06.30, 2018</p>
                </div>
              </article>
            </div>
            <div class="row-3">
              <article class="type-post">
                <div class="entry-cover">
                  <a title="Cover" v-on:click="goBlogDetail(3)"><img src="static/images/blog/3/3.png"></a>
                </div>
                <div class="entry-contentbox">
                  <div class="entry-title">
                    <a title="Single post with image" v-on:click="goBlogDetail(3)"><h3>영상 제작 어플리케이션 스냅무비 다운로드
                      500만명 돌파</h3></a>
                  </div>
                  <p class="post-date"><span class="font-color-afblue">Posted at </span>12.13, 2016</p>
                </div>
              </article>
            </div>
          </div>
        </div><!-- Related Post /- -->
      </div><!-- Content Area /- -->

    </div>
  </div><!-- Blog /- -->
</template>

<script>
  export default {
    name: 'Blog2',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      goBlogDetail( no ) {
        this.$router.push("Blog"+ no )
        //console.log('## click menu : ' + title)
        //this.menuVisible = false
        //this.$emit('clicked',title)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Blog2.vue